import Vue from 'vue'
import { Toast } from 'vant'
import axios from 'axios'
import {getParams, linkAuth, toLogin} from "@/utils/public"
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
Vue.prototype.$axiosServer = axios
// axios.defaults.baseURL = 'http://qwi.1000phone.net/qw/api/'
axios.defaults.baseURL = process.env.VUE_APP_API_HOST
// axios.defaults.baseURL = 'http://192.168.40.21:8789/qw/api/'
axios.defaults.headers.post['Content-Type'] =
  'content-type:application/json;charset=utf-8';
let loadingInstance = null;
let loadingCount = 0;
axios.interceptors.request.use(
  function (config) {
    config.headers.Authorization = localStorage.getItem('token');
    config.cancelToken = source.token;
    // config.headers.Authorization = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIxNTAwMDgzNDY4MCIsImV4cCI6MTY4OTk5MDcxMn0.iav3wv5m4X4W6VpxT3yAEaxqxXqcKt2ZzZxSUDJgxtM';
      if (loadingCount === 0) {
          if(config.url.includes('activityxet/generate')){
              loadingInstance = Toast.loading({
                  duration: 0, // 持续展示 toast
                  forbidClick: true,
                  message: "生成海报中..."
              });
          }else if(config.url.includes('weradarreading/weRadarStatisticsUser')){
            // 
          }else{
              loadingInstance = Toast.loading({
                  duration: 0, // 持续展示 toast
                  forbidClick: true,
                  message: "加载中..."
              });
          }
      }
      loadingCount++;
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
);
axios.interceptors.response.use(
    function (response) {
    loadingCount--;
    if (loadingInstance && loadingCount === 0) {
       loadingInstance.clear();
    }
    if (response.data.code == 900) {
        // source.cancel();
        localStorage.clear();
        if (
          !(window.location.search && getParams(window.location.search).code)
        ) {
          linkAuth(window.location.href.split("#")[0]);
        } else {
          toLogin();
        }
    }

    if (response.data.code == 200) {
      return response
    } else {
      return response
    }
  },
  function (error) {
      loadingInstance.clear();
      return Promise.reject(error);
        // if(axios.isCancel(error)){
        //     return new Promise(() => {});
        // }else{
        //     return Promise.reject(error);
        // }
  }
)

let httpServer = function (method, url, params, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      params: params || {},
      data: data || {},
      timeout: 30000,
      responseType: 'json',
      headers: {
        Authorization: localStorage.getItem("token"),
        // Authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIxNTAwMDgzNDY4MCIsImV4cCI6MTY4OTk5MDcxMn0.iav3wv5m4X4W6VpxT3yAEaxqxXqcKt2ZzZxSUDJgxtM',
      },
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        console.log(err)
        reject(err)
      })
  })
}
export { httpServer }
